import { useState } from "react";
import { motion } from "framer-motion";
import { ChevronRight, Cpu } from "lucide-react";
import { SYSTEMS } from "@/data";

export default function SystemsExplorer() {
    const [category, setCategory] = useState(0);
    const [selected, setSelected] = useState(SYSTEMS[0].items[0]);

    const pickCategory = (i) => {
        setCategory(i);
        setSelected(SYSTEMS[i].items[0]);
    };

    return (
        <div className="mt-20" data-testid="systems-explorer">
            <p className="text-sm font-semibold tracking-[0.3em] uppercase text-sky-200 mb-4" data-testid="systems-eyebrow">
                Inside the Guardian
            </p>
            <h3 className="font-display font-semibold text-3xl md:text-4xl" data-testid="systems-heading">
                Twenty-three systems, one continuous clean
            </h3>
            <p className="mt-4 text-lg text-slate-400 max-w-3xl leading-relaxed">
                Select a system group to see how each Guardian navigates, collects, protects wildlife and reports
                its results back to council.
            </p>

            <div className="mt-8 flex flex-wrap gap-3" data-testid="systems-category-tabs">
                {SYSTEMS.map((group, i) => (
                    <button
                        key={group.category}
                        data-testid={`systems-category-${i}`}
                        onClick={() => pickCategory(i)}
                        className={`px-5 py-2.5 rounded-full text-sm font-semibold border transition-colors ${
                            category === i
                                ? "bg-sky-400 text-[#020D18] border-sky-400"
                                : "border-[#1C3A54] text-slate-300 hover:border-sky-200 hover:text-sky-200"
                        }`}
                    >
                        {group.category}
                    </button>
                ))}
            </div>

            <div className="mt-6 grid grid-cols-1 lg:grid-cols-5 gap-6">
                <div className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-2 gap-3 content-start" data-testid="systems-item-list">
                    {SYSTEMS[category].items.map((item, i) => (
                        <button
                            key={item.title}
                            data-testid={`systems-item-${category}-${i}`}
                            onClick={() => setSelected(item)}
                            className={`text-left px-5 py-4 rounded-xl border transition-colors flex items-center justify-between gap-3 ${
                                selected.title === item.title
                                    ? "bg-[#0B2440] border-sky-400/60"
                                    : "bg-[#06182A] border-[#12283C] hover:border-sky-400/40"
                            }`}
                        >
                            <span className={`text-base font-semibold ${selected.title === item.title ? "text-sky-200" : "text-slate-200"}`}>
                                {item.title}
                            </span>
                            <ChevronRight className={`w-4 h-4 shrink-0 ${selected.title === item.title ? "text-sky-200" : "text-slate-500"}`} />
                        </button>
                    ))}
                </div>

                <motion.div
                    key={selected.title}
                    initial={{ opacity: 0, y: 12 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.35 }}
                    className="lg:col-span-2 bg-[#05251C] border border-emerald-900/60 rounded-xl p-7"
                    data-testid="systems-detail-card"
                >
                    <div className="flex items-center gap-3 mb-4">
                        <span className="w-10 h-10 rounded-lg bg-emerald-400/10 border border-emerald-400/30 flex items-center justify-center">
                            <Cpu className="w-5 h-5 text-emerald-300" />
                        </span>
                        <p className="text-xs font-semibold tracking-[0.25em] uppercase text-emerald-300/80">
                            {SYSTEMS[category].category}
                        </p>
                    </div>
                    <p className="font-display font-semibold text-2xl text-slate-50" data-testid="systems-detail-title">
                        {selected.title}
                    </p>
                    <p className="mt-3 text-base text-slate-300 leading-relaxed" data-testid="systems-detail-text">
                        {selected.detail}
                    </p>
                </motion.div>
            </div>
        </div>
    );
}
